import { usePreviewPanelsActions } from '@atlassian/preview-panels-api/use-preview-panel-actions';
import { usePreviewPanelsContext } from '@atlassian/preview-panels-api/preview-panel-context';

import { useRightSidebarContext } from '@confluence/page-layout-context';
import { useObjectSidebarActions } from '@confluence/object-sidebar-api/entry-points/useObjectSidebar.ts';

export const useClosePreviewPanel = () => {
	const context = usePreviewPanelsContext();
	const { hideObjectSidebar } = useObjectSidebarActions();
	const { close } = usePreviewPanelsActions();
	const { closeAll } = useRightSidebarContext();

	const closeObjectSidebar = () => {
		window.dispatchEvent(new Event('closeGlobalSidebar'));
		hideObjectSidebar();
	};

	const closeOnlyPreviewPanel = (onClose?: () => void): void => {
		if (context?.state?.panel) {
			close(onClose);
		}
	};

	const closeAllPanels = (): void => {
		closeAll();
		closeObjectSidebar();
	};

	return { closeAllPanels, closeOnlyPreviewPanel };
};
